<template lang='pug'>
  v-footer#dashboard-core-footer
    v-container
      v-col(align="center" no-gutters="")
        v-layout().footer-row
          v-col(cols="5")
            h3.footer-core__title.white--text.text-left.text-uppercase Gana dinero con nosotros
            v-row(no-gutters)
              span(v-if="static_pages")
                v-col.pa-0.footer-core__information.text-left(v-for="(item, index) in static_pages")
                  a.mr-0.white--text.text-uppercase(v-if="item.type === 'Tender'" @click="goTostatic(item)") {{item.title}}
          v-col(cols="5")
            h3.footer-core__title.white--text.text-left.text-uppercase Información de interés
            v-row(no-gutters)
              span(v-if="static_pages")
                v-col.pa-0.footer-core__information.text-left(v-for="(item, index) in static_pages")
                  a.mr-0.white--text.text-uppercase(v-if="item.type === 'Interes'" @click="goTostatic(item)") {{item.title}}
                v-col.pa-0.footer-core__information.text-left.text-uppercase
                  a.m-0.white--text(href="#/blog" v-text="'Blog'")
          v-col(cols="2")
            h3.footer-core__title.white--text.text-left Siguenos en
            v-row
              div( v-for="(item, i) in socialNetworks" :key="i").pa-0
                v-btn.ma-2(fab target="_blank" small color="success" icon="" :href="item.url")
                  v-icon(v-if="item.icon" color="white") {{item.icon}}
                  v-avatar(else size='16')
                    v-img(:src='item.img')
        v-row(no-gutters).d-flex.align-center.justify-center.mt-4
          v-col.footer-core__copyright(cols="12" md="auto")
            p.font-weight-light.white--text
              span &copy; TENDER  2020
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',

    data: () => ({
      links: [
        {
          href: '#',
          text: 'Creative Tim',
        },
        {
          href: '#',
          text: 'About Us',
        },
        {
          href: '#',
          text: 'Blog',
        },
        {
          href: '#',
          text: 'Licenses',
        },
      ],
      socialNetworks: [
        {
          icon: 'mdi-facebook',
          url: 'https://www.facebook.com/Tenderapp.co/',
        },
        // {
        //   icon: 'mdi-youtube',
        //   url: 'https://www.youtube.com/channel/UCSkN8c4SJO1uyBHfZbQnxuQ?view_as=subscriber',
        // },
        {
          icon: 'mdi-instagram',
          url: 'https://www.instagram.com/tender.app/',
        },
      ],
    }),

    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      static_pages () {
        return this.$store.getters['cms/getStatic']
      },
    },

    methods: {
      goTostatic (item) {
        const vm = this
        vm.isLoading = true
        vm.$store.dispatch('cms/getItem', { context: 'static', id: item.id }).then(function () {
          const transformRoute = item.title.split(' ').join('_')
          vm.$router.replace(`/tender/${transformRoute}`)
        })
      },
    },
  }
</script>

<style lang="scss">
  #dashboard-core-footer{
    width: 100%;
    margin: auto auto 0;
    height: 45vh;
    background-image: linear-gradient(
        to right bottom,
        rgba(#3c8f9f, 0.8),
        rgba(#2e1b6d, 0.8)),
    url(../../../../assets/images/footer-image.png);
    background-size: cover;
    background-position: top;
    position: relative;

  }
  .footer-core{
    height: 229px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #ffffff;

    &__title {
      color: #ffffff;
      padding-bottom: 1rem;
    }
    &__sections,
    &__information{
      display: flex;
      justify-content: space-between;
      flex-direction: column !important;
      flex-wrap: nowrap !important;
      a{
        padding: 5px;
        border-bottom:  1px solid transparent;
      }
    }
    &__information{
      flex-wrap: wrap;
      a {
        flex: 0 1 33.3%;
      }
    }
    &__lang{
      span{
        padding: 5px;
        border: 1px solid #ffffff;
      }
      span:nth-child(1){
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
      span:nth-child(2){
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }
    }
    &__social{
      width: 75%;
    }
    &__copyright{
      display: flex;
      height: max-content;
      color: #ffffff;
      a{
        text-decoration: underline !important;
        padding-left: .5rem !important;
        color: #ffffff;
      }
    }
    @media (max-width: 1264px) {
      &__sections,&__information{
        flex-direction: column;
      }
    }
  }
  .footer-row{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
  }
</style>
